// ./app/shared/hidden.directive.ts
import { Directive, ElementRef, Renderer2 } from '@angular/core';

// Directive decorator
@Directive({ selector: '[form-child]' })
// Directive class
export class FormChildDirective {

  isChild: boolean = false;

  constructor(private el: ElementRef,private renderer: Renderer2) {}

  hide(){
    if (this.isChild) {
      this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/form/core/directive/form-child.directive.ts